import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import CountryAdd from './add';
import CountryDelete from './delete';
import axios from 'axios';
import { baseUrl } from '../../../api/common';

const Country = () => {

    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = (status,type,data) => {
        setUpdateData(data);
        setEventType(type);
        setAddPopupStatus(status);
        setViewPopupStatus(false);   
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);
    
    const handleViewPopup = (type,data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const handleViewPopupClose = () => {
        setEventType('');
        setUpdateData({});
        setViewPopupStatus(false);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = (id) => {
      setDeleteId(id);
      setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };

    const [countryData, setCountryData] = useState([]);

    const fetchCountryData = async () => {
        console.log(`${baseUrl}/api/get_country`);
        try {
          const response = await axios.get(
            `${baseUrl}/api/get_country`,   
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {          
            setCountryData(response.data.data);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };

    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Country Name',
                field: 'name',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }
        ],
        rows:countryData&&countryData.map((data, index) => ({
            sno: index + 1,
            name: data.country_name || "N/A",
            action: (
                <div>
                  <Tooltip text="Update" id="update" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                    className="btn btn-sm btn-default" 
                    title="Edit"
                    data-for="update" 
                    data-tip
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                  <Tooltip text="Delete" id="delete" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }} 
                    className="btn btn-sm btn-default" 
                    title="Delete"
                    data-for="delete" 
                    data-tip
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
            ),           
            clickEvent: () => handleViewPopup("Update",data),
        })),
    }

    useEffect(() => {
      fetchCountryData();
    }, []);

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Country Master</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Country Master</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true,"Add",{})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[10, 25, 50, 100]}
                                        entries={25}
                                        paging
                                        pagesAmount={3}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CountryAdd fetchCountryData={fetchCountryData} eventType={eventType} updateData={updateData} addPopupStatus={addPopupStatus} handleAddPopup={handleAddPopup} />
                <CountryDelete fetchCountryData={fetchCountryData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete}/>

                {updateData&&<div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Country</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button onClick={()=>handleDelete(updateData.id)} className="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i className="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={()=> handleAddPopup(true,"Update",updateData)} className="saveand_proced_button btn btn-outline-info btn-block" type="button"><i className="fa fa-edit"></i> Edit </button>
                                </div>
                                <span onClick={() =>handleViewPopupClose()} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Country Name</b> </small>
                                                            <p>{updateData.country_name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        </>

    );

}
export default Country
